import React from "react";
import AnimatedText from "./AnimatedText";   // Add at top
import mainlogo  from  "../images/mainlogo.png"
function Hero() {
 const scrollToContact = () => {
  const element = document.getElementById("contact");

  if (element) {
    const offset = -180; // Adjust this value (negative moves up, positive moves down)
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition + offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
};


  return (
<section 
  id="home" 
  className="bg-[#000000] text-white text-center py-10 sm:py-12 md:py-14 lg:py-16 relative overflow-hidden"

   style={{ backgroundImage: `url(${mainlogo})`,
   backgroundSize: "contain"
   }}
>
  {/* 🔥 50% transparent overlay */}
  <div className="absolute inset-0 bg-black/70"></div>

      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 sm:top-20 left-5 sm:left-10 w-48 h-48 sm:w-64 sm:h-64 md:w-72 md:h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
        <div className="absolute top-20 sm:top-40 right-5 sm:right-10 w-48 h-48 sm:w-64 sm:h-64 md:w-72 md:h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse animation-delay-2000"></div>
        <div className="absolute -bottom-4 sm:-bottom-8 left-1/2 transform -translate-x-1/2 w-48 h-48 sm:w-64 sm:h-64 md:w-72 md:h-72 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse animation-delay-4000"></div>
      </div>

      <div className="relative z-10 px-4 sm:px-6" data-aos="fade-up">
        <div className="overflow-hidden mb-3 sm:mb-4 w-full" style={{ overflow: 'hidden', position: 'relative' }}>
         <div className="overflow-hidden mb-3 sm:mb-4 w-full" style={{ overflow: 'hidden', position: 'relative' }}>
  <div 
  style={{
    display: 'flex',
    width: '100%',
    justifyContent: 'center'
  }}
>
<h2
  className="
    text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 
    font-extrabold tracking-wide 
    bg-clip-text text-transparent 
    leading-tight whitespace-nowrap flex-shrink-0
    bg-gradient-to-r from-white via-gray-200 to-white
    flex items-center 
  "
>
  {/* Gradient O */}
  <span
    className="bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent leading-none"
    style={{ fontSize: "1.09em" }}  // Slightly taller O 
  >
    O
  </span>

  {/* Perfectly aligned RISON */}
  <span className="text-white tracking-wide">
    RISON
  </span>
</h2>


</div>


</div>

        </div>
       <AnimatedText
  text="Your growth partner for clean energy, smart technology, and digital reach"
  className="
    text-yellow-300 
    mb-8 sm:mb-10 
    max-w-3xl mx-auto 
    text-sm sm:text-lg md:text-xl 
    px-2 sm:px-4 
    leading-relaxed 
    font-light 
    tracking-wide
  "
/>

  
        <button
          onClick={scrollToContact}
          className="bg-white text-black font-semibold px-6 sm:px-8 py-3 sm:py-4 rounded-lg hover:bg-gray-200 active:bg-gray-300 hover:scale-105 active:scale-95 transform transition-all duration-300 ease-in-out shadow-lg hover:shadow-xl text-sm sm:text-base touch-manipulation"
        >
          Contact Oʀɪsᴏɴ
        </button>
      </div>
    </section>
  );
}

export default Hero;

